import React, { Component } from "react";

import { Elements } from "react-stripe-elements";
import StripeBookingForm from "./StripeBookingForm";

class PaymentSection extends Component {
  render() {
    const {
      price,
      user,
      firstName,
      lastName,
      email,
      phone,
      password,
      address,
      city,
      zip,
      numBedrooms,
      numBathrooms,
      discountCode,
      selectedDate,
      selectedTime,
      frequency
    } = this.props;
    if (typeof window !== `undefined`) {
      return (
        <Elements>
          <StripeBookingForm
            name={`${firstName} ${lastName}`}
            firstName={firstName}
            user={user}
            lastName={lastName}
            email={email}
            phone={phone}
            password={password}
            address={address}
            city={city}
            zip={zip}
            price={price}
            numBathrooms={numBathrooms}
            numBedrooms={numBedrooms}
            discountCode={discountCode}
            selectedDate={selectedDate}
            selectedTime={selectedTime}
            frequency={frequency}
          />
        </Elements>
      );
    } else {
      return null;
    }
  }
}

export default PaymentSection;

/* <Field
          component={FormField}
          width="16"
          label="Discount Code"
          placeholder="Discount Code"
          name="discountCode"
        />  */



// WEBPACK FOOTER //
// ./src/components/Booking/FormContainer/PaymentSection.jsx